import { useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import React from 'react'

import { CartContext, LineItemContext, QuantityContext } from './CartContext'
import AddToWishlistLink from '../AddToWishlistLink'
import QuantityField from '../QuantityField'

class LineItem extends React.Component {
  static propTypes = {
    lineItem: PropTypes.object.isRequired,
    lineItemIndex: PropTypes.number.isRequired,
    renderItem: PropTypes.func.isRequired,
  }

  static contextType = CartContext

  getQuantity = () => {
    const cart = this.context
    const { lineItem } = this.props

    return cart.getQuantity(lineItem)
  }

  setQuantity = (quantity, quantityΔ) => {
    const cart = this.context
    const { lineItem } = this.props

    return cart.setQuantity(lineItem, quantity, quantityΔ)
  }

  render() {
    return (
      <LineItemContext.Provider value={this.props.lineItem}>
        <QuantityContext.Provider value={this}>
          {this.props.renderItem(this.props.lineItem, this.props.lineItemIndex)}
        </QuantityContext.Provider>
      </LineItemContext.Provider>
    )
  }
}

function RemoveLineItemButton(props) {
  const lineItem = React.useContext(LineItemContext)
  const cartContext = React.useContext(CartContext)

  return <button {...props} type="button" onClick={() => cartContext.setQuantity(lineItem, 0)} />
}

function CartQuantityField({ ...props }) {
  const lineItem = React.useContext(LineItemContext)
  const dispatch = useDispatch()
  const quantity = useSelector((state) =>
    state.getIn(['view', 'cart', 'quantities', lineItem.lineItemId], lineItem.quantity),
  )
  return <QuantityField {...{ ...props, quantity, lineItem, dispatch }} />
}

function AddToWishlistLinkInCart({ ...props }) {
  const lineItem = React.useContext(LineItemContext)
  const cart = React.useContext(CartContext)
  const allProps = {
    ...props,
    callAfterItemAddedToWishlist: () => cart.setQuantity(lineItem, 0),
    productId: lineItem.productId,
    quantity: lineItem.quantity,
    lineItemId: lineItem.lineItemId,
  }
  return <AddToWishlistLink {...allProps} />
}

export default Object.assign(LineItem, {
  RemoveLineItemButton,
  QuantityField: CartQuantityField,
  AddToWishlistLinkInCart,
})
